import { render, staticRenderFns } from "./SubstanceTableSearchOnlyV1.vue?vue&type=template&id=1f79e44a&"
import script from "./SubstanceTableSearchOnlyV1.vue?vue&type=script&lang=js&"
export * from "./SubstanceTableSearchOnlyV1.vue?vue&type=script&lang=js&"
import style0 from "./SubstanceTableSearchOnlyV1.vue?vue&type=style&index=0&id=1f79e44a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports